<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-10">
      <v-icon x-large class="v-icon-delete">
        mdi-delete-alert-outline
      </v-icon>

      <div v-if="currentImageItem">
        <v-card-title class="text-h6 pp-center">
          Are you sure you want to delete the Image of "{{ currentImageItem.originalName }}"?
        </v-card-title>

        <p class="pp-center pb-5">
          This image will be deleted immediately. You can't undo this action.
        </p>
      </div>

      <div v-else>
        <UnavailableContent />
      </div>

      <Loading v-if="imageItemLoading" />

      <ConfirmCancelButtons
          :item="currentImageItem"
          :confirm-disabled="imageItemLoading"
          confirm-text="Delete Image"
          :confirm-action="deleteItemConfirm"
          cancel-class="mr-5"
          :cancel-action="closeDialog"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import UnavailableContent from "@/components/common/UnavailableContent";

export default {
  name: "ImageDelete",
  components: {UnavailableContent, Loading, ConfirmCancelButtons},
  computed: {
    ...mapState(['currentImageItem']),
    ...mapGetters(['imageApiError', 'openDialog', 'currentImageItem', 'imageItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'imageDelete';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['deleteImage', 'clearImageItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearImageItems();
    },
    async deleteItemConfirm() {
      const deleted = await this.deleteImage(this.currentImageItem);
      if (deleted) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
